import { Injectable } from '@angular/core';
import * as bcrypt from 'bcryptjs';
import * as md5 from 'md5';

@Injectable()
export class CryptoService {

  private saltRounds = 10;

  constructor() {
  }

  public async encrypt(data: string): Promise<any> {
    return bcrypt.hash(data, this.saltRounds)
  }

  public async compare(data: string, hash: string): Promise<boolean> {
    return bcrypt.compare(data, hash);
  }

  public md5(data: string): string {
      return md5(data);
  }
}
